// extracted by mini-css-extract-plugin
export default {"pifflePlaque":"pifflePlaque_pifflePlaque__lVtpl","deEmphasised":"pifflePlaque_deEmphasised__WUiZt","artistName":"pifflePlaque_artistName__gnGa-","info":"pifflePlaque_info__XaY0x"};